import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleQueryKeys, Roles } from '#api';

export function useDeleteRoleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (roleID: string) => Roles.deleteRole(roleID),
    onSuccess: (data, roleID) => {
      queryClient.removeQueries({ queryKey: roleQueryKeys.detail(roleID), exact: true });
      void queryClient.invalidateQueries({ queryKey: roleQueryKeys.lists() });
    },
  });
}
